<template>
  <div class="ma-2">
    <v-data-table
      :headers="headers"
      :items="itens"
      :options.sync="options"
      :server-items-length="totalItens"
      :loading="loading"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 50, 100],
        showFirstLastPage: true,
        itemsPerPageText: 'Itens por página',
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
      @page-count="pageCount = $event">
        <template v-slot:top>
          <v-form @submit="pesquisar()" v-on:submit.prevent>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select clearable v-model="pesquisa.cc_fil" label="Empresa" placeholder="" :items="filiais" item-text="cc_fil" item-value="cc_fil"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10">
                  <v-text-field clearable v-model="pesquisa.cc_pdv" label="Código" placeholder=""></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                  <v-btn depressed outlined color="primary" type="submit">
                    pesquisar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
        <template v-slot:item.cc_tkn={item}>
          <v-icon @click="copiar(item.cc_tkn)">mdi-content-copy</v-icon> {{item.cc_tkn}}
        </template>
        <template v-slot:item.tx_dados_ativacao={item}>
          <v-icon @click="copiar(item.tx_dados_ativacao)">mdi-content-copy</v-icon> {{item.tx_dados_ativacao.substring(0,45)}}...
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-icon color="primary" v-if="item.bl_tkn_atv" large v-on="on" @click="ativar(item)">mdi-check-circle</v-icon>
            </template>
            <span>Disponibilizar</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-icon color="primary" large v-on="on" @click="abrirModulosMFE(item)">mdi-alpha-m-box</v-icon>
            </template>
            <span>M&oacute;dulos CF-e</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <!--v-alert border="top" colored-border color="primary" elevation="2" class="mt-2"-->
      <v-card outlined>
        
        <v-toolbar flat color="accent">
          <v-toolbar-title>Inserir Novo Ponto de Venda</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-form  ref="form" @submit="salvar()" v-model="valid" :lazy-validation="lazy" id="edit-form" v-on:submit.prevent>
            <v-container fluid>
              <v-row v-if="pdv.id_reg != undefined">
                <v-col cols="12" class="text-center">
                  <v-chip
                    v-if="pdv.id_reg != undefined"
                    close
                    @click:close="resetarFormulario()">
                    {{ pdv.cc_pdv }}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select item-text="cc_fil" item-value="cc_fil" label="Empresa" :items="filiais" v-model="pdv.cc_fil" :rules="validacao.cc_fil" :disabled="disabled"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10">
                  <v-text-field label="Código" v-model="pdv.cc_pdv" :rules="validacao.cc_pdv" :disabled="disabled"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-btn depressed outlined color="primary" type="submit">{{ pdv.id_reg != undefined ? 'CONFIRMAR' : 'CONFIRMAR'}}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
      <!--/v-alert-->
      <pm-modulocfe :pdv='mfe.pdv' :modal='mfe.modal' :key="mfe.key" v-on:a="mfe.modal=false;mfe.pdv=undefined"></pm-modulocfe>
  </div>
</template>
<script>
  import lodash from 'lodash'
  import ModuloCFE from './ModuloCFE.vue'

  export default {

    components: {
      'pm-modulocfe': ModuloCFE
    },

    data () {
      return {

        /** atributos da paginacao */
        page: 1,
        pageCount: 0,
        itemsPerPage: 5,
        totalItens: 0,
        itens: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Empresa', value: 'cc_fil', sortable:false, width: 80 },
          { text: 'Código', value: 'cc_pdv', sortable:false, width: 80 },
          { text: 'Token', value: 'cc_tkn', sortable:false, width: 380},
          { text: 'Ativador', value: 'tx_dados_ativacao', sortable:false},
          { text: '', value: 'action', sortable:false, width:150, align: 'right'},
        ],

        /** atributos da pesquisa*/
        pesquisa: {
          cc_fil: undefined,
          cc_pdv: undefined
        },

        /** propriedades de persistencia*/
        lazy: false,
        valid: true,
        disabled: false,

        filiais:[],
        cfops:[],
        csticms: [],
        cstpis:[],
        cstcofins:[],
        origens:[],
        parcelas:[{qtd:0},{qtd:1},{qtd:2},{qtd:3},{qtd:4},{qtd:5},{qtd:6},{qtd:7},{qtd:8},{qtd:9},{qtd:10},{qtd:11},{qtd:12}],
        pdv: {
          id_reg: undefined,
          cc_fil: undefined,
          cc_pdv: undefined
        },

        validacao: {
          cc_fil:[
            (v) => !!v || 'Requerido',
          ],
          cc_pdv:[
            (v) => !!v || 'Requerido',
            (v) => /^[ 0-9]*$/.test(v) || 'Formato inválido'
          ]
        },

        mfe: {
          modal: false,
          pdv: undefined,
          key: undefined
        }

      }
    },

    watch: {
      options: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              this.itens = data.items
              this.totalItens = data.total
              this.pageCount = data.totalPages
            })
        },
        deep: true,
      },
    },

    mounted () {
      
      this.getDataFromApi()
        .then(data => {
          this.itens = data.items
          this.totalItens = data.total
        })

      this.populaFiliais()

    },

    created(){
      this.$vuetify.goTo(0)
    },

    methods: {

      editar(obj){
        this.key_component_preco++
        this.key_component_ean++
        this.disabled = true
        this.pdv = lodash.clone(obj)
        this.$vuetify.goTo('#edit-form', {duration: 500,
          offset: 0,
          easing: 'linear',
        })
      },

      salvar() {

        if (this.$refs.form.validate()) {
          // eslint-disable-next-line no-unused-vars
          this.$store.dispatch('salvarPDV', this.pdv).then(resp => {

            if(this.pdv.id_reg !== undefined) {
              let item = this.itens.filter((el) => {return el.id_reg === this.pdv.id_reg})
              if(item.length > 0){
                Object.assign(this.itens[this.itens.indexOf(item[0])], this.pdv)
              }
            }

            this.resetarFormulario()
          }).catch(err => {
            console.log(err)
          })

        }
      },

      abrirModulosMFE(item) { 
        this.mfe.key = Math.random() * Math.random()
        this.mfe.pdv = item
        this.mfe.modal = true
      },

      resetarFormulario() {
        this.disabled = false
        this.pdv.id_reg = undefined
        this.$refs.form.reset()
      },

      pesquisar() {
        this.resetarFormulario()
        this.page = 1
        this.getDataFromApi()
          .then(data => {
            this.itens = data.items
            this.totalItens = data.total
          })
      },

      populaFiliais() {
        this.$store.dispatch('obterFiliais', {}).then(resp => {
          this.filiais = resp.data.content
        }).catch(err => {
          console.log(err)
        })
      },

      ativar(item) {
        this.$store.dispatch('ativarPDV', item.id_reg).then(() => {
          item.bl_tkn_atv = !item.bl_tkn_atv
        }).catch()
      },

      copiar(str) {

        console.log(str)

        this.$copyText(str).then(function () {
          alert('Copiado para a área de transferência')
        }, function () {
          alert('Can not copy')
        })

      },

      getDataFromApi () {

        this.loading = true

        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {

          // eslint-disable-next-line no-unused-vars
          const { sortBy, sortDesc, page, itemsPerPage } = this.options

          let params = {
            page: page-1,
            size: itemsPerPage === -1 ? 999999999 : itemsPerPage
          };

          let filtro = lodash.omitBy(Object.assign(params, this.pesquisa), o => !o)

          this.$store.dispatch('pesquisaPDV', filtro).then( resp => {

            this.loading = false

            let items        = resp.data.content
            const total      = resp.data.totalElements
            const totalPages = resp.data.totalElements

            resolve( { items, total, totalPages } )

          }).catch( err => {
            console.log(err)
          })

        })
      }
    },
  }
</script>